<script lang="ts" setup>
	defineProps<{
		steps: {
			[id: string]: {
				completed: boolean
				active?: boolean
			}
		}
	}>()
</script>

<template>
	<div class="relative overflow-x-auto">
		<div class="steps -x-5 relative mx-auto flex items-center">
			<div
				class="absolute bottom-6 left-0 right-0 top-0 z-10 mx-auto my-auto inline-flex h-1 w-full max-w-[70%] bg-gray-100"
			/>
			<div
				v-for="(item, key, index) in steps"
				:key="index"
				class="relative mx-auto inline-flex flex-1 flex-col items-center"
				:class="[item.completed ? 'before:bg-primary-100' : 'before:bg-gray-200']"
			>
				<div :data-step="item" class="flex flex-none items-center">
					<div
						class="border-1 relative z-10 inline-flex h-[40px] w-[40px] flex-none flex-col items-center justify-center rounded-full border text-base font-medium sm:text-lg"
						:class="[
							item.completed || item.active
								? 'border-primary-2 text-primary-2'
								: 'border-gray-400 bg-gray-50 text-gray-500',
							item.completed ? 'bg-primary-2' : 'bg-primary-50'
						]"
					>
						<div v-show="item.completed">
							<lazy-tools-icon icon="check" dir="line" />
						</div>
						<span v-show="!item.completed">
							{{ index + 1 }}
						</span>
					</div>
				</div>

				<span
					class="mt-2 whitespace-nowrap px-3 text-center font-medium tracking-wide sm:px-0"
					:class="[item.completed || item.active ? 'font-semibold text-primary-2' : 'text-gray-600']"
				>
					{{ key }}
				</span>
			</div>
		</div>
	</div>
</template>
